import { utils } from '@neo-one/utils';
import { BaseScriptBuilder } from './BaseScriptBuilder';
export class EmittingScriptBuilder extends BaseScriptBuilder {
    constructor({ context, scopes, helpers, sourceFile, linked, contractInfo, allHelpers, }) {
        super(context, helpers, sourceFile, contractInfo, linked, allHelpers);
        this.scopes = scopes;
    }
    createScope(node, index) {
        return utils.nullthrows(utils.nullthrows(this.scopes.get(node)).get(index));
    }
}

//# sourceMappingURL=EmittingScriptBuilder.js.map
